import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiConfig from "../../../../common/config/ApiConfig";
import { useLanguage } from "../../../../common/i18n/LanguageContext";

// Read-only for now — the backend only exposes GET /getCurrencyList (no
// create/update/delete endpoints yet), so this just lists the seeded
// currencies rather than offering edit controls with nothing to call.
function CurrencyTab() {
  const { t } = useLanguage();
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    ApiConfig.get("/getCurrencyList").then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      setCurrencies(Array.isArray(result.data) ? result.data : []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-white p-3 rounded-lg shadow-sm overflow-x-auto">
      <table className="text-[14px]">
        <thead>
          <tr className="bg-gray-100">
            <th className="py-1 px-2 text-left whitespace-nowrap">
              {t("settings_currency_col_code")}
            </th>
            <th className="py-1 px-2 text-left whitespace-nowrap">
              {t("settings_currency_col_name")}
            </th>
            <th className="py-1 px-2 text-left whitespace-nowrap">
              {t("settings_currency_col_symbol")}
            </th>
            <th className="py-1 px-2 text-left whitespace-nowrap">
              {t("settings_currency_col_status")}
            </th>
          </tr>
        </thead>
        <tbody>
          {currencies.map((currency, index) => (
            <tr
              key={currency.id}
              className={`whitespace-nowrap ${
                index % 2 === 0 ? "bg-gray-50" : "bg-white"
              }`}
            >
              <td className="py-1 px-2 font-bold">{currency.code}</td>
              <td className="py-1 px-2">{currency.name}</td>
              <td className="py-1 px-2">{currency.symbol}</td>
              <td className="py-1 px-2">
                <span
                  className={`inline-block px-2 py-0.5 rounded-full font-semibold text-[9px] ${
                    currency.status
                      ? "bg-green-100 text-green-800"
                      : "bg-slate-200 text-slate-700"
                  }`}
                >
                  {currency.status
                    ? t("agentadd_status_active")
                    : t("agentadd_status_inactive")}
                </span>
              </td>
            </tr>
          ))}
          {currencies.length === 0 && (
            <tr>
              <td colSpan={4} className="py-4 text-center text-slate-400">
                {t("common_no_data")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CurrencyTab;
